import { merge } from 'lodash-es'
import actions from './actions'

const state = {
  hotTopics: [],
  topicRanking: {
    list: [],
    pageSize: 20, // 一页几笔
    total: 0, // 总笔数
    page: 1, // 第几页
    pages: 1, // 总页数
  }
}

const getters = {
}

const mutations = {
  setHotTopics(state, data) {
    state.hotTopics = data
  },
  setTopicRanking(state, data) {
    state.topicRanking = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
